import axios from 'axios';
import { HOST } from '../../domain/http'

const register = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=crearBancoMiBitpos`,
    data: {
        ...body,
        "requestUser": "AddBank"
    },
});

const retrieve = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=getBancoPais`,
    data: body,
});

const retrieveAccountTypes = async (countryCode) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=getBancoTiposCuenta`,
    data: countryCode,
});

const retrieveCurrencyTypes = async (countryCode) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=getBancoMoneda`,
    data: countryCode,
});

const retrieveBankData = async (body) => {
    const types = retrieveAccountTypes(body);
    const currencys = retrieveCurrencyTypes(body);

    const formArray = (obj) => {
        let data = [];
        for (const k in obj) {
            data.push({ id: k, value: obj[k] })
        }
        return data;
    }

    return Promise.all([types, currencys]).then((values) => {
        return {
            data: {
                types: formArray(values[0].data),
                currencys: formArray(values[1].data)
            },
            status: values[0].status === values[1].status ? values[0].status : 400
        }
    });
}

export { register, retrieve, retrieveBankData };